import React from 'react';
import { ExecutiveMessage } from '../../services/messages.service';

type Props = {
  messages: ExecutiveMessage[];
  canEdit: boolean;
  onEdit: (type: 'CHAIRMAN' | 'MD') => void;
  onView: (type: 'CHAIRMAN' | 'MD') => void;
  getProfilePicture: (type: 'CHAIRMAN' | 'MD') => string | undefined;
  getContent: (type: 'CHAIRMAN' | 'MD') => string;
};

const MessagesCard: React.FC<Props> = ({ messages, canEdit, onEdit, onView, getProfilePicture, getContent }) => {
  return (
    <>
      <div className="sidebar-card message-card" onClick={() => onView('CHAIRMAN')}>
        <div className="message-header">
          <h4>Message From Chairman</h4>
          {canEdit && (
            <button className="edit-message-btn" onClick={(e) => { e.stopPropagation(); onEdit('CHAIRMAN'); }}>✏️</button>
          )}
        </div>
        {getProfilePicture('CHAIRMAN') && (
          <div className="message-profile-picture">
            <img src={getProfilePicture('CHAIRMAN')} alt="Chairman" />
          </div>
        )}
        <div className="message-content">
          <p>{getContent('CHAIRMAN')}</p>
        </div>
      </div>

      <div className="sidebar-card message-card" onClick={() => onView('MD')}>
        <div className="message-header">
          <h4>Message From MD</h4>
          {canEdit && (
            <button className="edit-message-btn" onClick={(e) => { e.stopPropagation(); onEdit('MD'); }}>✏️</button>
          )}
        </div>
        {getProfilePicture('MD') && (
          <div className="message-profile-picture">
            <img src={getProfilePicture('MD')} alt="MD" />
          </div>
        )}
        <div className="message-content">
          <p>{getContent('MD')}</p>
        </div>
      </div>
    </>
  );
};

export default MessagesCard;
